import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import ReactToggle from "react-toggle"; 
import 'react-toggle/style.css';  
import { Col, Row } from 'reactstrap';
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from '../../store/Functions';
import { useDispatch } from 'react-redux';
import { API_WEB_URLS } from '../../constants/constAPI';
import { useLocation } from 'react-router-dom';
import { Container } from 'react-bootstrap';

function AddEdit_UserMaster() {
    const API_URL = API_WEB_URLS.MASTER + "/0/token/UserType"; 
    const API_URL_SAVE = API_WEB_URLS.UserMaster + "/0/token";
    const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/User/Id";
  const [state, setState] = useState({
    id: 0,
    FillArray : [],
    formData: {},
    OtherDataScore: [],
    isProgress: true,
  });
  const dispatch = useDispatch();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const location = useLocation();
  useEffect(() => {
    Fn_FillListData(dispatch, setState, 'FillArray', API_URL + '/Id/0');
     
    const Id = (location.state &&  location.state.Id) || 0 ;
  
    if(Id > 0 ){
        Fn_DisplayData(dispatch,setState,Id,API_URL_EDIT)
    }
  }, []);

  const validationSchema = Yup.object({
    Name: Yup.string().required('Name is required'),
    Phone: Yup.string().required('Phone is required'),
    Email: Yup.string().email('Invalid email format').required('Email is required'),
    Password: Yup.string().min(4, 'Password must be at least 8 characters').required('Password is required'),
    Address: Yup.string().required('Address is required'),
    ShopName: Yup.string().required('Shop Name is required'),
    IsActive: Yup.boolean().required("Active status is required") 
  });

  const [showOpeningStock, setShowOpeningStock] = useState(false);

  const handleUserTypeChange = (event) => {
    const { value } = event.target;
    setShowOpeningStock(value === 'Customer');
  };

  const handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    console.log(values);
    let vformData = new FormData();
   
    vformData.append("F_UserType", values.F_UserType);
    vformData.append("Name", values.Name);
    vformData.append("Password", values.Password);
    vformData.append("Phone", values.Phone);
    vformData.append("Email", values.Email);
    vformData.append("Address", values.Address);
    vformData.append("Shop Name", values.Address);
    vformData.append("IsActive", values.IsActive );
    vformData.append("UserId", obj.uid);
    Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: 0, formData: vformData } },
        API_URL_SAVE,
        true,
        "memberid"
      );
   
  };

  return (
    <div className='page-content'>
    <Container boxed={true}>
      <Formik
        initialValues={{
          ...state.formData,
          IsActive: state.formData.IsActive || false,  
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({  setFieldValue, values }) => (
          <Form className="form-horizontal">
          <Row>
   
      <Col lg='6' className="mb-3">
        <label htmlFor="F_UserType" className="form-label">UserType</label>
        <Field
          className="form-control"
          as="select"
          name="F_UserType"
          onChange={(event) => {
            handleUserTypeChange(event);  
             
          }}
        >
          <option value="">Select UserType</option>
          <option value="Agent"   >Agent</option>
          <option value="Customer">Customer</option>
          <option value="Staff"   >Staff</option>
           
          {/* {state.FillArray.map((UserType) => (
            <option key={UserType.Id} value={UserType.Id}>{UserType.Name}</option>
          ))} */}
        </Field>
        <ErrorMessage name="F_UserType" component="div" className="text-danger" />
      </Col>
    </Row>

    <Row>

    {showOpeningStock && (
        <Col lg='6' className="mb-3">
          <label htmlFor="OpeningStock" className="form-label">Opening Stock</label>
          <Field
            className="form-control"
            type="number"
            name="OpeningStock"
            placeholder="Enter Opening Stock"
          />
          <ErrorMessage name="OpeningStock" component="div" className="text-danger" />
        </Col>
      )}
    </Row>


            <Row>
            <Col lg='6' className="mb-3">
              <label htmlFor="Name" className="form-label">Name</label>
              <Field className="form-control" type="text" name="Name" />
              <ErrorMessage name="Name" component="div" className="text-danger" />
            </Col>
            </Row>
            <Row>
            <Col lg='6' className="mb-3">
              <label htmlFor="Phone" className="form-label">Phone</label>
              <Field className="form-control" type="number" name="Phone" />
              <ErrorMessage name="Phone" component="div" className="text-danger" />
            </Col>
            </Row>
          
            <Row>
            <Col lg='6' className="mb-3">
              <label htmlFor="Email" className="form-label">Email</label>
              <Field className="form-control" type="email" name="Email" />
              <ErrorMessage name="Email" component="div" className="text-danger"/>
            </Col>
            </Row>
            <Row>
            <Col lg='6' className="mb-3">
              <label htmlFor="Password" className="form-label">Password</label>
              <Field className="form-control" type="password" name="Password" />
              <ErrorMessage name="Password" component="div" className="text-danger"/>
            </Col>
            </Row>
            <Row>
            <Col lg='6' className="mb-3">
              <label htmlFor="Address" className="form-label">Address</label>
              <Field className="form-control" type="text" name="Address" />
              <ErrorMessage name="Address" component="div" className="text-danger" />
            </Col>
            </Row>
            <Row>
            <Col lg='6' className="mb-3">
              <label htmlFor="ShopName" className="form-label"> Shop Name</label>
              <Field className="form-control" type="text" name="ShopName" />
              <ErrorMessage name="ShopName" component="div" className="text-danger" />
            </Col>
            </Row>
            <Row>
                <Col lg='1' className='mb-3'>
                  <label htmlFor='IsActive' className='form-label'>
                    Active
                  </label>
                </Col>
                <Col lg='2'>
                  <ReactToggle
                    checked={values.IsActive}
                    onChange={() => setFieldValue('IsActive', !values.IsActive)}
                  />
                  <ErrorMessage name='IsActive' component='div' className='text-danger' />
                </Col>
              </Row>

            <button type="submit" className="btn btn-primary btn-block">
              Submit
            </button>
           
          </Form>
        )}
      </Formik>
      </Container>
    </div>
  );
}

export default AddEdit_UserMaster;
